import { Popover } from "@datamole/wds-component-popover";
import { PopoverContentProps } from "@radix-ui/react-popover";
import clsx from "clsx";
import { forwardRef } from "react";

import styles from "./content.module.css";

type Props = PopoverContentProps;

const MenuContent = forwardRef<HTMLDivElement, Props>((props, ref) => {
    const { children, className, side = "right", align = "center", ...otherProps } = props;

    return (
        <Popover.Content
            {...otherProps}
            side={side}
            align={align}
            className={clsx(styles.menu_content, className)}
            ref={ref}
        >
            {children}
        </Popover.Content>
    );
});

MenuContent.displayName = "Menu.Content";

export { MenuContent };
export type { Props as MenuContentProps };
